import { Component, Label, _decorator } from 'cc';
import TableModel from '../../../../tableEngine/Script/Game/Data/Model/TableModel';
import BaseMachineInfo from '../GameObject/MachineInfo/BaseMachineInfo';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';
import Dialog from '../../../../common/scripts/Toolkit/Components/Dialog/Dialog';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ResumeGamePopup')
@requireComponent(Dialog)
export default class ResumeGamePopup extends Component {
    @property(BaseMachineInfo)
    private readonly machineInfo: BaseMachineInfo = null;

    @property(Label)
    private readonly firstMessageLabel: Label = null;

    private _page: Page = null;
    private _dialog: Dialog = null;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    private get dialog() {
        if (!this._dialog) {
            this._dialog = this.getComponent(Dialog);
        }
        return this._dialog;
    }

    public onLoad() {
        this.firstMessageLabel.registerTextChangeCallback((str: string) => {
            this.firstMessageLabel.node.active = !!str;
            return str;
        });
    }

    public async showResumeHint(model: TableModel): Promise<boolean> {
        this.machineInfo.updateInfo(model);
        this.page.open();
        const result = await this.dialog.waitForNextAction();
        return result === Dialog.EVENT_TYPE.CONFIRM;
    }
}
